import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class contentPresetEdit_template extends vnTemplate {

    protected getTemplateHtml(): string {
        return `
            <div class="form-header">
                <h3 class="form-title">Content Preset</h3>
                <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>
            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group">                  
                        <input type="checkbox" data-bind="checked: isActive" id="is-active">
                        <label for="is-active" class="form-label icon i-check">Is Active</label>                               
                    </div>
                    <div class="form-group row">
                        <label for="type" class="form-label form-label form-label-box">Type</label>
                        <select name="" id="" data-bind="value: type">
                            <option value="template">Template</option>
                        </select>
                    </div>                
                    <div class="form-group row" data-bind="visible: type() == 'template'">
                        <label for="" class="form-label form-label-box">Template</label>
                        <select name="" id="" data-bind="value: idItem">
                            <option value="2">Regular</option>
                            <option value="3">List</option>
                            <option value="9">Buyer's Guide Light</option>
                            <option value="10">Deals</option>
                            <option value="12">Collection</option>
                            <option value="7">Directory</option>
                            <option value="11">Versus</option>
                            <option value="13">Sub-Content</option>
                            <option value="14">How to Watch</option>
                        </select>
                    </div>
                </div>    
                <div class="form-body">
                </div>        
            </div>
            <div class="form-body">
                <div class="form-group">
                    <hr>
                </div>
                <div class="form-group">
                     <label for="contenttext" class="form-label">Content</label>
                     <textarea id="contenttext" data-bind="value: content"></textarea>
                </div> 
            </div>
            
             <div class="form-footer">                
                <button data-bind="event: { click: onClickCancelEdit }" class="btn" type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>            
            </div> 
            `;
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form", "w-form-large"];
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable("")
            , type: ko.observable("")
            , idItem: ko.observable("")
            , content: ko.observable("")
            , isActive: ko.observable(false)
            , onClickCancelEdit: function (data, event) {
                self.onClickCancelEdit();

            },onClickSave: function (data, event) {
                self.onClickSave()
            }
        }
    }

    protected getTemplateName(): string {
        return "contentPresetEdit_template";
    }

    public setId(id){
        this.getTemplateViewModel().id(id)
    }

    public setType(type){
        this.getTemplateViewModel().type(type)
    }

    public setIdItem(idItem){
        this.getTemplateViewModel().idItem(idItem)
    }

    public setContent(content){
        this.getTemplateViewModel().content(content)
    }

    public setIsActive(isActive){
        this.getTemplateViewModel().isActive(isActive)
    }

    protected onClickCancelEdit(): any {
        this.caller.onClickCancelEdit();
    }

    protected onClickSave(): any {
        this.caller.save()
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/contentPresetEdit_template.ts